module.exports = __webpack_public_path__ + "img/B-7.8cd51372.png";